module.exports = __webpack_public_path__ + "static/media/push-icon.fe0be50d.svg";